var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTabletAndLower)?_c('HeaderMobile',_vm._g(_vm._b({},'HeaderMobile',_vm.headerProps,false),_vm.headerEmits)):_c('HeaderDesktop',_vm._g(_vm._b({},'HeaderDesktop',_vm.headerProps,false),_vm.headerEmits))
}
var staticRenderFns = []

export { render, staticRenderFns }